import { home } from './home/home.module';
import { homeAboutUs } from './home-about-us/home-about-us.module';
import { homeFeatureList } from './home-feature-list/home-feature-list.module';
import { homeLatestNews } from './home-latest-news/home-latest-news.module';
import { homeLatestProgressReports } from './home-latest-progress-reports/home-latest-progress-reports.module';
import { transportationAlternatives } from './transportation-alternatives/transportation-alternatives.module';
import { transportationCallForHelp } from './transportation-call-for-help/transportation-call-for-help.module';
import { transportationRidesharing } from './transportation-ridesharing/transportation-ridesharing.module';
import { transportationBicycleAndPedestrain } from './transportation-bicycle-and-pedestrian/transportation-bicycle-and-pedestrian.module';
import { transportationProviders } from './transportation-providers/transportation-providers.module';
import { transportationProviderDetails } from './transportation-provider-details/transportation-provider-details.module';
import { publicationsDocuments } from './publications-documents/publications-documents.module';
import { publicationsDocumentsProgressReports } from './publications-documents-progress-reports/publications-documents-progress-reports.module';
import { publicationsDocumentsMilepost } from './publications-documents-milepost/publications-documents-milepost.module';
import { publicationsDocumentsConferenceMaterials } from './publications-documents-conference-materials/publications-documents-conference-materials.module';
import { publicationsDocumentsCallCenterStatistics } from './publications-documents-call-center-statistics/publications-documents-call-center-statistics.module';
import { planningResources } from './planning-resources/planning-resources.module';
import { planningResourcesDataMappingTool } from './planning-resources-data-mapping-tool/planning-resources-data-mapping-tool.module';
import { planningResourcesCensusData } from './planning-resources-census-data/planning-resources-census-data.module';
import { planningResourcesMobilityManagement } from './planning-resources-mobility-management/planning-resources-mobility-management.module';
import { planningResourcesVolunteerPrograms } from './planning-resources-volunteer-programs/planning-resources-volunteer-programs.module';
import { planningResourcesTransportationServices } from './planning-resources-transportation-services/planning-resources-transportation-services.module';
import { planningResourcesFtaFactSheetsCirculars } from './planning-resources-fta-fact-sheets-circulars/planning-resources-fta-fact-sheets-circulars.module';
import { planningResourcesTransportationPlans } from './planning-resources-transportation-plans/planning-resources-transportation-plans.module';
import { gettherePrograms } from './getthere-programs/getthere-programs.module';
import { aboutUs } from './about-us/about-us.module';
import { aboutUsOurStaff } from './about-us-our-staff/about-us-our-staff.module';
import { aboutUsInTheNews } from './about-us-in-the-news/about-us-in-the-news.module';
import { aboutUsNewsDetails } from './about-us-news-details/about-us-news-details.module';
import { aboutUsMissionHistory } from './about-us-mission-history/about-us-mission-history.module';
import { aboutUsPartnersStakeholders } from './about-us-partners-stakeholders/about-us-partners-stakeholders.module';
import { aboutUsRuralHealthNetwork } from './about-us-rural-health-network/about-us-rural-health-network.module';
import { tripPlanner } from './trip-planner/trip-planner.module';
import { aboutUsInTheNewsArchive } from './about-us-in-the-news-archive/about-us-in-the-news-archive.module';
import { publicationsDocumentsMilepostArchive } from './publications-documents-milepost-archive/publications-documents-milepost-archive.module';
import { publicationsDocumentsProgressReportsArchive } from './publications-documents-progress-reports-archive/publications-documents-progress-reports-archive.module';
import { searchResult } from './search-result/search-result.module';
import { termsAndCondition } from './terms-and-condition/terms-and-condition.module';
import { privacyPolicy } from './privacy-policy/privacy-policy.module';
import { planningResourcesReferenceMaterials } from './planning-resources-reference-materials/planning-resources-reference-materials.module'
import { aboutUsAdvisoryCommittee } from './about-us-advisory-committee/about-us-advisory-committee.module';
import { subscribe } from './subscribe/subscribe.module';
import { pageNotFound } from './page-not-found/page-not-found.module';
import { dynamicMenus } from './dynamic-menus/dynamic-menus.module';
import { editorDescriptionPage } from './editor-description-page/editor-description-page.module';
import { planningResourcesReferenceMap } from './planning-resources-reference-map/planning-resources-reference-map.module';

export const components = angular
	.module('components', [
		home,
		homeAboutUs,
		homeFeatureList,
		homeLatestNews,
		homeLatestProgressReports,
		transportationAlternatives,
		transportationCallForHelp,
		transportationRidesharing,
		transportationBicycleAndPedestrain,
		transportationProviders,
		transportationProviderDetails,
		publicationsDocuments,
		publicationsDocumentsProgressReports,
		publicationsDocumentsMilepost,
		publicationsDocumentsConferenceMaterials,
		publicationsDocumentsCallCenterStatistics,
		planningResources,
		planningResourcesDataMappingTool,
		planningResourcesCensusData,
		planningResourcesMobilityManagement,
		planningResourcesVolunteerPrograms,
		planningResourcesFtaFactSheetsCirculars,
		planningResourcesTransportationPlans,
		gettherePrograms,
		planningResourcesTransportationServices,
		aboutUs,
		aboutUsOurStaff,
		aboutUsInTheNews,
		aboutUsNewsDetails,
		aboutUsMissionHistory,
		aboutUsPartnersStakeholders,
		aboutUsRuralHealthNetwork,
		tripPlanner,
		searchResult,
		aboutUsInTheNewsArchive,
		publicationsDocumentsMilepostArchive,
		publicationsDocumentsProgressReportsArchive,
		termsAndCondition,
		privacyPolicy,
		planningResourcesReferenceMaterials,
		aboutUsAdvisoryCommittee,
		subscribe,
		pageNotFound,
		dynamicMenus,
		editorDescriptionPage,
		planningResourcesReferenceMap
	])
	.name;


// WEBPACK FOOTER //
// ./src/app/components/components.module.js